import * as z from 'zod';

import { permissibleRouteKeys, type PermissibleRouteKeys } from '../../../../../_shared/routes-widgets/configs';

export const permissionsActions = z.enum(['view', 'create', 'update', 'revert', 'delete']);
export const permissionsResourceType = z.enum(['model', 'widget', 'tab']);

export { permissibleRouteKeys, type PermissibleRouteKeys };

export type PermissionsActions = z.infer<typeof permissionsActions>;
export type PermissionsResourceType = z.infer<typeof permissionsResourceType>;

export const permissionsQuerySchema = z.object({
  id: z.number(),
  role_id: z.number(),
  action: permissionsActions,
  resource_type: permissionsResourceType,
  resource: permissibleRouteKeys.or(z.string()),
});

export type PermissionsQuerySchema = z.infer<typeof permissionsQuerySchema>;

export const permissionsFormSchema = permissionsQuerySchema.extend({
  value: z.boolean(),
  index: z.number(),
});

export type PermissionsFormSchema = z.infer<typeof permissionsFormSchema>;

export type PermissionsUpdateSchema = Omit<PermissionsQuerySchema, 'value' | 'index'>;

export type PermissionsCreateSchema = Omit<PermissionsUpdateSchema, 'id'>;
